import {
  focusEditor,
  getPluginOptions,
  PlateEditor,
  Value,
} from '@udecode/plate-common';
import { LinkPlugin, validateUrl } from '@udecode/plate-link';

import { ELEMENT_LINK } from '../../../plateTypes';
import {
  floatingLinkActions,
  floatingLinkSelectors,
} from '../hooks/floatingLinksStore';
import { upsertAnchorLink } from './upsertAnchorLink';
import { upsertLink } from './upsertLink';
import { upsertInterlink } from './index';

/**
 * Insert link if url is valid. Text is url if empty. Close floating link. Focus
 * editor.
 */
export const submitFloatingLink = <V extends Value>(
  editor: PlateEditor<V>,
): boolean | void => {
  if (!editor.selection) return;
  if (floatingLinkSelectors.linkType() === 'article') {
    const linkId = floatingLinkSelectors.interlinkId();
    const linkTitle = floatingLinkSelectors.interlinkTitle();
    const text = floatingLinkSelectors.text();
    const langId = floatingLinkSelectors.interlinkLangId();
    floatingLinkActions.hide();
    upsertInterlink(editor, {
      linkId,
      linkTitle,
      text,
      langId,
    });
  }

  if (floatingLinkSelectors.linkType() === 'url') {
    // From Plate docs: Determines whether to force the submission of the link form.
    const { forceSubmit } = getPluginOptions<LinkPlugin, V>(
      editor,
      ELEMENT_LINK,
    );

    const url = floatingLinkSelectors.url();
    if (!forceSubmit && !validateUrl(editor, url)) return;

    const text = floatingLinkSelectors.text();
    const target = floatingLinkSelectors.newTab() ? '_blank' : undefined;
    floatingLinkActions.hide();
    upsertLink(editor, {
      url,
      text,
      target,
      skipValidation: true,
    });
  }

  if (floatingLinkSelectors.linkType() === 'anchor') {
    const linkId = floatingLinkSelectors.linkedElementId();
    const text = floatingLinkSelectors.text();
    floatingLinkActions.hide();

    upsertAnchorLink(editor, {
      linkId,
      text,
    });
  }

  setTimeout(() => {
    focusEditor(editor, editor.selection!);
  }, 0);

  return true;
};
